import { PaymentResultModel } from '@/model/payment';
import * as api from '@/utils/api';

/*发起订单在线支付*/
export const startPayment = (data: any): Promise<api.ApiResult<PaymentResultModel>> =>
  api.post<PaymentResultModel>('/payment/start', data);
